import { render, staticRenderFns } from "./CreateNewCheckerboard.vue?vue&type=template&id=6bf0adca"
import script from "./CreateNewCheckerboard.vue?vue&type=script&lang=js"
export * from "./CreateNewCheckerboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports